import countryNames from "./country-names";
export const isOldWorld = countryName => {
  const country = countryNames.find(
    country => country.name.toLowerCase() === countryName.toLowerCase(),
  );
  return country && country.isOldWorld;
};
